/**
 * The editor's HTML as sent: every paragraph with zero margin and padding
 * and line height 1.4 inline, as the Inbox sends it, and the editor-only
 * class names dropped. Mail clients give a bare <p> a blank line above and
 * below; this sends what the editor shows.
 */
const emailBodyHtml = (html) =>
  String(html || "")
    .replace(/\s(class|dir)="[^"]*"/gi, "")
    .replace(/<p(\s[^>]*)?>/gi, (tag, attrs = "") => {
      const tight = "margin:0;padding:0;line-height:1.4;";
      return /style\s*=\s*"/i.test(attrs)
        ? `<p${attrs.replace(/style\s*=\s*"/i, `style="${tight}`)}>`
        : `<p${attrs} style="${tight}">`;
    });

export default emailBodyHtml;
